module.exports = __webpack_public_path__ + "static/media/IMG_0755.fca28387.jpg";